<template>
  <div
    id="app"
    :class="{ 'account-page': $route.path.startsWith('/center'), 'checkout-page': isCheckoutRoute }"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <jxw-header v-if="!isFullscreenRoute"></jxw-header>
    <div :class="['content-box', {
      'content-box--fullscreen': isFullscreenRoute,
      'content-box--photography': isPhotographyRoute,
      'content-box--account': $route.path.startsWith('/center') || isCheckoutRoute,
    }]">
      <router-view />
    </div>
    <jxw-footer
      v-if="
          !isFullscreenRoute &&
          $route.path != '/login' &&
          $route.path != '/register' &&
          $route.path != '/'
      "
    ></jxw-footer>
    <el-backtop v-if="!isFullscreenRoute" :visibility-height="300"> </el-backtop>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      loading: (state) => state.loading, // 加载动画
    }),
    isFullscreenRoute() {
      return this.$route.matched.some(
        (route) => route.meta && route.meta.fullscreen
      );
    },
    isCheckoutRoute() { return ["photographyAppointmentPayment", "photographyAppointmentConfirmation"].includes(this.$route.name); },
    isPhotographyRoute() {
      return this.$route.name === "photograph";
    },
  },
  components: {
    jxwHeader: () => import("@/components/header.vue"),
    jxwFooter: () => import("@/components/footer.vue"),
  },
};
</script>

<style>
* {
  font-family: "微软雅黑";
  font-size: 14px;
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: none !important;
}
a:active {
  text-decoration: none !important;
}
a:visited {
  text-decoration: none !important;
}
a:link {
  text-decoration: none !important;
}
ul {
  list-style: none;
  margin: 0;
}
p,
dl,
dd {
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  height: 100%;
  margin: 0px;
  padding: 0px;
}

.content-box {
  min-height: 100%;
  padding-top: 80px;
}

.content-box--fullscreen {
  padding-top: 0;
}

@media (max-width: 767px) {
  .content-box--photography:not(.content-box--fullscreen) {
    padding-top: 104px;
  }
}

/* bootstrap */
input[type="file"] {
  display: none;
}
/* 图片加载失败 */
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;
}
.image-slot > i {
  font-size: 30px;
  color: #909399;
}
/* 列表页分页器容器 */
.page-box {
  padding: 50px 0;
  text-align: right;
}
/* 评分组件 */
.el-icon-star-on {
  font-size: 18px;
}
</style>

<style>
#app:is(.account-page, .checkout-page) .center_box,
#app:is(.account-page, .checkout-page) .center_box * {
    font-family: "Noto Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif;
}
#app:is(.account-page, .checkout-page) .center_box [class*="el-icon-"] {
    font-family: element-icons !important;
}
@media (max-width: 767px) {
    #app:is(.account-page, .checkout-page) .content-box--account {
        padding-top: 104px;
    }
    #app:is(.account-page, .checkout-page) .footer-box {
        height: auto !important;
        background-image: none !important;
        background: #fff;
        padding: 28px 20px;
    }
    #app:is(.account-page, .checkout-page) .footer-box > .container {
        width: 100%;
        padding: 0;
        box-sizing: border-box;
    }
    #app:is(.account-page, .checkout-page) .footer-text {
        margin: 0;
    }
    #app:is(.account-page, .checkout-page) .footer-text > p {
        font-size: 14px;
        line-height: 1.7;
    }
    #app:is(.account-page, .checkout-page) .footer-text > .footer-text-feedback {
        font-size: 16px;
        margin: 16px 0;
    }
    #app:is(.account-page, .checkout-page) .footer-wechat {
        margin: 20px 0;
        padding: 0;
        display: flex;
        align-items: center;
    }
    #app:is(.account-page, .checkout-page) .footer-wechat > img {
        width: 90px;
        height: 90px;
    }
    #app:is(.account-page, .checkout-page) .footer-wechat-text > span {
        font-size: 14px;
    }
    #app:is(.account-page, .checkout-page) .footer-other {
        position: static;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-top: 24px;
    }
    #app:is(.account-page, .checkout-page) .footer-other > a + a {
        margin: 0;
    }
    #app:is(.account-page, .checkout-page) .footer-copy {
        position: static;
        margin-top: 16px;
        font-size: 12px;
        line-height: 1.8;
        overflow-wrap: anywhere;
    }
    #app:is(.account-page, .checkout-page) .footer-copy a {
        display: inline-block;
        font-size: 12px;
    }
    #app:is(.account-page, .checkout-page) .footer-emblem {
        margin-left: 0;
    }
    #app.checkout-page .footer-box { padding-bottom: 96px; }
    body:has(#app:is(.account-page, .checkout-page)) .el-dialog {
        max-width: calc(100% - 24px);
    }
    body:has(#app:is(.account-page, .checkout-page)) .el-message {
        min-width: 0;
        max-width: calc(100% - 24px);
    }
}
</style>
